// extracted by mini-css-extract-plugin
module.exports = {"time":"VideoTimer_time__U_6Mo","list":"VideoTimer_list__HbiL_","detail":"VideoTimer_detail__UDeDC"};